import { ErrorBoundary, TagField } from "@prismicio/editor-ui"
import { Suspense, useState } from "react"

import { useRepositoryTags } from "../app/services/repository"
import { useDocument } from "./DocumentProvider"

export function DocumentTags() {
  const { draft } = useDocument()
  const [open, setOpen] = useState(false)

  function onSelectedValuesChange(newValue: Set<string>) {
    draft.updateTags(newValue)
  }

  return (
    <ErrorBoundary
      renderError={() => (
        <TagField
          selectedValues={draft.documentTags}
          onSelectedValuesChange={onSelectedValuesChange}
          error
          open={open}
          setOpen={setOpen}
        />
      )}
    >
      <Suspense
        fallback={
          <TagField
            selectedValues={draft.documentTags}
            onSelectedValuesChange={onSelectedValuesChange}
            loading
            open={open}
            setOpen={setOpen}
          />
        }
      >
        <RepositoryPopulatedTagField
          open={open}
          setOpen={setOpen}
          selectedValues={draft.documentTags}
          onSelectedValuesChange={onSelectedValuesChange}
        />
      </Suspense>
    </ErrorBoundary>
  )
}

interface RepositoryPopulatedTagFieldProps {
  open: boolean
  setOpen: (open: boolean) => void
  selectedValues: Set<string>
  onSelectedValuesChange: (selectedValues: Set<string>) => void
}

function RepositoryPopulatedTagField(props: RepositoryPopulatedTagFieldProps) {
  const repositoryTags = new Set(useRepositoryTags().results)

  return <TagField {...props} values={repositoryTags} />
}
